export default __webpack_public_path__ + "static/media/icici-client.cbe564e5.webp";